import { useEffect, useState } from 'react'
import { Toaster } from 'react-hot-toast'
import { useAuth } from './hooks/useAuth'
import { useActivation } from './hooks/useActivation'
import { validateToken } from './lib/authClient'
import { readAuthToken } from './lib/authToken'
import ActivationPage from './pages/ActivationPage'
import CabinetSetupPage from './pages/CabinetSetupPage'

function App() {
  const { hasAccess, token, authInitialized, markHasAccess, markNoAccess, redirectToLogin } = useAuth()
  const { cabinetSerial, slotPosition } = useActivation()
  const [loading, setLoading] = useState(true)


  useEffect(() => {
    const processAuth = async () => {
      if (!authInitialized) return

      if (import.meta.env.VITE_BYPASS_AUTH === 'true') {
        markHasAccess()
        setLoading(false)
        return
      }

      const effectiveToken = token || readAuthToken()

      if (!effectiveToken) {
        setLoading(false)
        redirectToLogin()
        return
      }

      try {
        await validateToken()
        markHasAccess()
      } catch (error) {
        console.error('Token validation failed:', error)
        markNoAccess()
        redirectToLogin()
      } finally {
        setLoading(false)
      }
    }

    processAuth()
  }, [authInitialized, token, markHasAccess, markNoAccess, redirectToLogin])

  if (!authInitialized || loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900">
        <h1 className="text-4xl font-bold text-gray-100">Loading...</h1>
      </div>
    )
  }

  // If loading is done but we don't have access, we are likely redirecting.
  // Returning null avoids showing the app content or the loading screen while the redirect happens.
  if (!hasAccess) {
    return null
  }


  const hasCabinetSelected = Boolean(cabinetSerial) && Number.isInteger(slotPosition)

  return (
    <div>
      <Toaster
        position="top-center"
        reverseOrder={false}
        toastOptions={{
          className: '',
          style: {
            background: '#333',
            color: '#fff',
          },
        }}
      />
      {hasCabinetSelected ? <ActivationPage /> : <CabinetSetupPage />}
    </div>
  )
}

export default App
